import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

export default class LocationOverviewEmployeesGroupsController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { Groups } = await import('reactRichComponents/groups/Groups');

    this.root = await this.reactRenderer.render(Groups, 'react__employee-groups');
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
